<template>
  <div>
    <el-dialog :visible.sync="modalConfirmPublish" :show-close="false" :title="$t('socialPosts.create.planification.title')" :v-loading="loadingStatus">
      <p>{{ $t('socialPosts.create.planification.instruction') }}</p>
      <div v-if="facebookChecked" style="border: 1px;border-color: #1e4a56;margin: 15px;">
        <el-row>
          <el-col :lg="24"><h3>
            <img
                alt=""
                :src="require(`@/assets/facebook-logo-5-1.png`)"
                width="20"
                style="padding-bottom: 8px;margin-right:15px;"
            />Facebook</h3>
          </el-col>
        </el-row>
        <el-row v-if="!storePost.facebook.alreadyPublished">
          <el-col :lg="12">
            <el-date-picker
                size="mini"
                :picker-options="pickerOptions"
                ref="picker"
                type="datetime"
                format="dd/MM/yyyy HH:mm"
                :clearable="false"
                v-model="facebookDatePlanif"
                :placeholder="$t('socialPosts.create.planification.selectDateTime')">
            </el-date-picker>
          </el-col>
          <el-col :lg="12">
            <el-checkbox v-model="facebookPublishNow">{{ $t('socialPosts.create.planification.publishNow') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row v-else>
          {{ $t('socialPosts.create.planification.alreadyPublishedFacebook') }}
        </el-row>
      </div>
      <div v-if="instagramChecked" style="border: 1px;border-color: #1e4a56;margin: 15px;">
        <el-row>
          <el-col :lg="24"><h3><img
              alt=""
              :src="require(`@/assets/2048px-Instagram_icon.png`)"
              width="20"
              style="padding-bottom: 8px;margin-right:15px;"
          />Instagram</h3></el-col>
        </el-row>
        <el-row v-if="!storePost.instagram.alreadyPublished">
          <el-col :lg="12">
            <el-date-picker
                size="mini"
                :picker-options="pickerOptions"
                ref="picker"
                type="datetime"
                format="dd/MM/yyyy HH:mm"
                :clearable="false"
                v-model="instagramDatePlanif"
                :placeholder="$t('socialPosts.create.planification.selectDateTime')">
            </el-date-picker>
          </el-col>
          <el-col :lg="12">
            <el-checkbox v-model="instagramPublishNow">{{ $t('socialPosts.create.planification.publishNow') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row v-else>
          {{ $t('socialPosts.create.planification.alreadyPublishedInstagram') }}
        </el-row>
      </div>
      <div v-if="googleChecked" style="border: 1px;border-color: #1e4a56;margin: 15px;">
        <el-row>
          <el-col :lg="24"><h3><img
              alt=""
              :src="require(`@/assets/1200px-Google-My-Business_logo.svg.png`)"
              width="20"
              style="padding-bottom: 8px;margin-right:15px;"
          />Google</h3></el-col>
        </el-row>
        <el-row  v-if="!storePost.google.alreadyPublished">
          <el-col :lg="12">
            <el-date-picker
                size="mini"
                :picker-options="pickerOptions"
                ref="picker"
                type="datetime"
                format="dd/MM/yyyy HH:mm"
                :clearable="false"
                v-model="googleDatePlanif"
                :placeholder="$t('socialPosts.create.planification.selectDateTime')">
            </el-date-picker>
          </el-col>
          <el-col :lg="12">
            <el-checkbox v-model="googlePublishNow">{{ $t('socialPosts.create.planification.publishNow') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row v-else>
          {{ $t('socialPosts.create.planification.alreadyPublishedGoogle') }}
        </el-row>
      </div>
      <div v-if="linkedInChecked" style="border: 1px;border-color: #1e4a56;margin: 15px;">
        <el-row>
          <el-col :lg="24"><h3><img
              alt=""
              :src="require(`@/assets/linkedin-logo.png`)"
              width="20"
              style="padding-bottom: 8px;margin-right:15px;"
          />LinkedIn</h3></el-col>
        </el-row>
        <el-row  v-if="!storePost.linkedin.alreadyPublished">
          <el-col :lg="12">
            <el-date-picker
                size="mini"
                :picker-options="pickerOptions"
                ref="picker"
                type="datetime"
                format="dd/MM/yyyy HH:mm"
                :clearable="false"
                v-model="linkedInDatePlanif"
                :placeholder="$t('socialPosts.create.planification.selectDateTime')">
            </el-date-picker>
          </el-col>
          <el-col :lg="12">
            <el-checkbox v-model="linkedInPublishNow">{{ $t('socialPosts.create.planification.publishNow') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row v-else>
          {{ $t('socialPosts.create.planification.alreadyPublishedLinkedin') }}
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">

      <el-button type="primary" @click="validate" :disabled="disabled || loading" :loading="loading">
            <span>{{ $t('socialPosts.create.planification.apply') }}</span>
         </el-button>

      <el-button @click="closeModal">
            <span>{{
                $t('portals.list.close')
              }}</span>
         </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'DialogPlanifPostEditorial',
  props: ['post'],
  data () {
    return {
      disabled: false,
      loading: false
    }
  },
  computed: {
    ...mapState('socialPostsCreationPostEditorial', [
      'modalConfirmPublish',
      'facebookChecked',
      'instagramChecked',
      'googleChecked',
      'linkedInChecked',
      'loadingStatus']),
    ...mapGetters('socialPostsCreationPostEditorial',
      ['getModalConfirmPublish']
    ),
    modalConfirmPublish: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.modalConfirmPublish
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublish', value)
      }
    },
    facebookDatePlanif: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.facebook.datePlanif || undefined
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setFacebookDatePlanif', value)
        if (value) {
          this.$store.commit('socialPostsCreationPostEditorial/setFacebookPublishNow', false)
        }
      }
    },
    instagramDatePlanif: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.instagram.datePlanif || undefined
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setInstagramDatePlanif', value)
        if (value) {
          this.$store.commit('socialPostsCreationPostEditorial/setInstagramPublishNow', false)
        }
      }
    },
    googleDatePlanif: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.google.datePlanif || undefined
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setGoogleDatePlanif', value)
        if (value) {
          this.$store.commit('socialPostsCreationPostEditorial/setGooglePublishNow', false)
        }
      }
    },
    linkedInDatePlanif: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.linkedin.datePlanif || undefined
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setLinkedInDatePlanif', value)
        if (value) {
          this.$store.commit('socialPostsCreationPostEditorial/setLinkedInPublishNow', false)
        }
      }
    },
    facebookPublishNow: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.facebook.publishNow
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setFacebookPublishNow', value)
        if (value) {
          this.$store.commit('socialPostsCreationPostEditorial/setFacebookDatePlanif', null)
        }
      }
    },
    instagramPublishNow: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.instagram.publishNow
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setInstagramPublishNow', value)
        if (value) {
          this.$store.commit('socialPostsCreationPostEditorial/setInstagramDatePlanif', null)
        }
      }
    },
    googlePublishNow: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.google.publishNow
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setGooglePublishNow', value)
        if (value) {
          this.$store.commit('socialPostsCreationPostEditorial/setGoogleDatePlanif', null)
        }
      }
    },
    linkedInPublishNow: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.linkedin.publishNow
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setLinkedInPublishNow', value)
        if (value) {
          this.$store.commit('socialPostsCreationPostEditorial/setLinkedInDatePlanif', null)
        }
      }
    },
    storePost () {
      return this.$store.state.socialPostsCreationPostEditorial.post
    },
    pickerOptions () {
      return {
        disabledDate (time) {
          const today = new Date()
          const yesterday = new Date(today)
          yesterday.setDate(today.getDate() - 1)
          return time.getTime() < yesterday.getTime()
        }
      }
    }
  },
  methods: {
    closeModal () {
      this.disabled = false
      this.loading = false
      this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublish', false)
      // Émettre un événement pour informer le parent que la modale se ferme
      this.$emit('modal-closed')
    },

    async validate () {
      if (this.$store.getters['socialPostsCreationPostEditorial/hasMediaConflict']) {
        this.$store.commit('socialPostsCreationPostEditorial/setPendingActionType', 'validatePlanification')
        this.$store.commit('socialPostsCreationPostEditorial/setModalMediaImageAndVideo', true)
        return
      }

      // Vérifier que tous les réseaux cochés ont une planification valide
      let allNetworksValid = true

      if (this.facebookChecked && !this.storePost.facebook.alreadyPublished) {
        if (!this.storePost.facebook.datePlanif && !this.storePost.facebook.publishNow) {
          allNetworksValid = false
        }
      }
      if (this.instagramChecked && !this.storePost.instagram.alreadyPublished) {
        if (!this.storePost.instagram.datePlanif && !this.storePost.instagram.publishNow) {
          allNetworksValid = false
        }
      }
      if (this.googleChecked && !this.storePost.google.alreadyPublished) {
        if (!this.storePost.google.datePlanif && !this.storePost.google.publishNow) {
          allNetworksValid = false
        }
      }
      if (this.linkedInChecked && !this.storePost.linkedin.alreadyPublished) {
        if (!this.storePost.linkedin.datePlanif && !this.storePost.linkedin.publishNow) {
          allNetworksValid = false
        }
      }

      // Vérifier qu'au moins un réseau est coché
      const hasCheckedNetworks = this.facebookChecked || this.instagramChecked || this.googleChecked || this.linkedInChecked

      if (allNetworksValid && hasCheckedNetworks) {
        this.disabled = true
        this.loading = true

        // Forcer la mise à jour de Vue
        this.$forceUpdate()
        await this.$nextTick()

        try {
          await this.$store.dispatch('socialPostsCreationPostEditorial/handlePublish')
        } catch (error) {
          console.error('Erreur lors de la planification:', error)
        } finally {
          this.disabled = false
          this.loading = false
          this.$forceUpdate()
          // Émettre un événement pour informer le parent que la modale se ferme après validation
          this.$emit('modal-closed')
        }
      } else {
        // Afficher un message d'erreur si la validation échoue
        if (!hasCheckedNetworks) {
          this.$message.error('Veuillez sélectionner au moins un réseau social')
        } else if (!allNetworksValid) {
          this.$message.error('Veuillez définir une date de planification ou cocher "Publier maintenant" pour tous les réseaux sélectionnés')
        }
      }
    }
  },
  watch: {
    modalConfirmPublish (newVal) {
      // Désactiver le loader quand la modale se ferme
      if (!newVal) {
        this.disabled = false
        this.loading = false
        // Émettre un événement pour informer le parent que la modale se ferme
        this.$emit('modal-closed')
      }
    }
  },
  beforeMount () {
    this.disabled = false
    this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublish', false)
  }
}
</script>

<style scoped>
.info-no-planification {
  color: #ffc107;
}
</style>
